import { useTranslation } from "react-i18next";

import { Campaign } from "@/hooks/api/predictive/product/useGetAllProducts";
import Badge from "@/components/atoms/Badge";

type CampaignStatusBadgeProps = {
  campaign: Campaign;
};

const CampaignStatusBadge = ({ campaign }: CampaignStatusBadgeProps) => {
  const { t } = useTranslation();
  const { status, canceled, period_end } = campaign;

  switch (status) {
    case "ACTIVE":
      return canceled ? (
        <Badge
          label={t("predictive.campaign.status.canceled", { date: new Date(period_end).toLocaleDateString() })}
          color={"success"}
          size={"sm"}
        />
      ) : (
        <Badge label={t("predictive.campaign.status.active")} color={"success"} size={"sm"} />
      );
    case "DRAFT":
      return <Badge label={t("predictive.campaign.status.draft")} color={"warning"} size={"sm"} />;
    default:
      return <Badge label={t("predictive.campaign.status.inactive")} color={"natural"} size={"sm"} />;
  }
};

export default CampaignStatusBadge;
